(function($) {
  $(function() {
    var table = $('#sortTable');

    if (!table.length || typeof table.DataTable !== 'function') {
      return;
    }

    table.DataTable({
      lengthChange: false,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Zoeken..',
        zeroRecords: 'Geen resultaten gevonden'
      }
    });
  });
})(jQuery);
